import React from 'react';

export default React.memo(function ShadowCard({ className = '', children }) {
  return (
    <div className={`w-full h-full rounded-3xl bg-white p-6 shadow-2xl select-none ${className}`}>
      {children}
    </div>
  );
})
